import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = ({ currentUser, history }) => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // Handle sell tickets link click with authentication check
  const handleSellTicketsClick = e => {
    e.preventDefault();
    if (!currentUser) {
      history.push('/login');
      return;
    }

    const isEmailVerified = currentUser?.attributes?.emailVerified;
    if (isEmailVerified !== true) {
      history.push('/verify-email');
      return;
    }
    history.push('/l/new');
  };

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
    // Add click handler for sell tickets link
    onSellTicketsClick: handleSellTicketsClick,
  };

  return <SectionBuilder sections={[footerSection]} />;
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return { currentUser };
};

const FooterContainer = compose(withRouter, connect(mapStateToProps))(FooterComponent);

export default FooterContainer;
